import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromStaticDataReducer from '../reducers';
import * as staticDataUploadedFileTypeReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataUploadedFileTypeState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataUploadedFileTypeReducer.uploadedFileTypeFeatureKey]
);

export const getStaticUploadedFileTypeFailure = createSelector(
  getStaticDataUploadedFileTypeState,
  staticDataUploadedFileTypeReducer.fromStaticDataUploadedFileTypeReducer.getStaticDataUploadedFileTypeFailure
);

export const getStaticDataUploadedFileTypeResponse = createSelector(
  getStaticDataUploadedFileTypeState,
  staticDataUploadedFileTypeReducer.fromStaticDataUploadedFileTypeReducer.getStaticDataUploadedFileTypeResponse
);
